module.exports = __webpack_public_path__ + "img/圆角矩形 4 拷贝 2@3x.f61f8f5e.png";